import { ReactNode, useCallback, useRef } from "react";
import { cva } from "class-variance-authority";
import { useInputGroupContext } from "./InputGroup";

export interface InputLeftAddonProps {
  className?: string;
  children: ReactNode;
}

const styles = cva(`absolute z-10 h-full flex items-center ml-1`, {
  variants: {},
});
/**
 *
 */
export const InputLeftAddon = ({
  className,
  children,
}: InputLeftAddonProps) => {
  const context = useInputGroupContext();
  const fn = useCallback(
    (ref: any) => ref && context?.setLeftWidth(ref.clientWidth),
    []
  );
  return (
    <div ref={fn} className={styles({ className })}>
      {children}
    </div>
  );
};
InputLeftAddon.id = "InputLeftAddon";
